import React, { useState, useEffect } from "react";
import arrowUp from "../assets/arrow-up.png";
import arrowDown from "../assets/arrow-down.png";
import back from "../assets/back.png";
import "../styles/selectProgram.css";
import '../styles/basicLayout.css'
import { useHistory, useParams } from "react-router-dom";
import ProductTemp from "../components/ProductTemp";
import { saveRecipe, getRecipe } from "../api";
import { MIN_GRILL_TEMP_F, MIN_PROD_TEMP_F, MIN_TIME_S, TERMS } from "../utils/constants";
import { mainBgColor } from "../utils/colors";
import CategorySelector from "../components/CategorySelector";
import Stages from '../components/Stages'
import { findRecipes } from "../api";

export const settings = {
  PRODUCT_TEMP: "PRODUCT_TEMP",
  GRILL_TEMP: "GRILL_TEMP",
  TIME: "TIME"
}


export function RunMode() {
  let history = useHistory();
  const { id } = useParams();
  const [selectedTerm, setSelectedTerm] = useState(null)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedRecipe, setSelectedRecipe] = useState(null)
  const [recipes, setRecipes] = useState([])
  const [setting, setSetting] = useState(settings.PRODUCT_TEMP)
  const [recipe, setRecipe] = useState({
    name: 'New recipe',
    stages: [
      {
        id: 0,
        product_temperature_f: MIN_PROD_TEMP_F,
        grill_temperature_f: MIN_GRILL_TEMP_F,
        time_s: MIN_TIME_S,
      }
    ],
    category: null,
    activeStage: 0,
    cooking_term: null,
  })

  const handleNextStage = () => {
    if (recipe.stages.length > recipe.activeStage + 1) {
      setRecipe({ ...recipe, activeStage: recipe.activeStage + 1 })
    }
    else {
      const stages = [...recipe.stages];
      stages.push({
        id: stages.length,
        product_temperature_f: 50,
        grill_temperature_f: 541,
        time_s: 60,
      })
      setRecipe({ ...recipe, activeStage: recipe.activeStage + 1, stages })
    }
  }

  const handleSetStage = newStage => {
    const stages = [...recipe.stages]
    stages[recipe.activeStage] = newStage
    setRecipe({ ...recipe, stages })
  }

  const handleSave = async () => {
    const resp = await saveRecipe(recipe)
    if (resp?.code === 1) {
      alert(`There was an error while saving the recipe, please try again later.`)
    }
    else {
      alert(`Succesfully saved recipe.`)
    }
  }

  const handleSetCategory = (category) => {
    setSelectedCategory(category)
  }

  const requestRecipe = async (id) => {
    const resp = await getRecipe({ id })
    setRecipe({
      ...resp.data,
      activeStage: 0
    })
  }

  useEffect(() => {
    if (selectedCategory !== null && selectedTerm !== null)
      handleFindRecipes()
  }, [selectedTerm, selectedCategory])

  const handleFindRecipes = async () => {
    const resp = await findRecipes({
      cooking_term: selectedTerm,
      category: selectedCategory
    })
    console.log({data: resp.data});
    setRecipes(resp?.data?.data)
  }

  return (
    <>
      <header>
        <div className="left">
          <img
            onClick={() => {
              history.goBack();
            }}
            className="btn"
            width="80px"
            src={back} alt="" />
          <h3 style={{ marginLeft: 10 }}>Click Dial</h3>
        </div>
        <div className="center" style={{ display: 'flex', flexDirection: 'column' }}>
          <p className="title">Run Mode</p>
        </div>
        <div className="right"></div>
      </header>
      <article>
        <div className="left" style={{ display: 'flex', flexDirection: 'column' }}></div>
        {recipes.length === 0 ?
          <div className="center">
            {(selectedCategory !== null && selectedTerm !== null) ?
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {(recipe.stages.length > 1 && recipe.activeStage >= 1) &&
                  <img
                    onClick={() => setRecipe({ ...recipe, activeStage: recipe.activeStage - 1 })}
                    style={{
                      margin: 10,
                    }}
                    width="70px"
                    src={arrowUp}
                    alt=""
                  />
                }
                <ProductTemp setting={setting} stage={recipe.stages[recipe.activeStage]} />
                <img
                  onClick={handleNextStage}
                  style={{
                    margin: 10,
                  }}
                  width="70px"
                  src={arrowDown}
                  alt=""
                />
              </div>
              :
              <CategorySelector handleSetCategory={handleSetCategory} category={selectedCategory} />
            }
          </div>
          :
          <div className="center"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              justifyContent: 'flex-start',
              overflow: 'auto',
              height: '100vh'
            }}
          >
            {recipes?.map(recipe => (
              <h3 
                className="list_elem"
                onClick={ () => {
                  history.push({
                    pathname:`/run/recipe/${recipe._id}`,
                    state: { recipe }
                  })
                }}
              > {recipe.name} </h3>
            ))}
          </div>
        }


        <div className="right" style={{ ...(recipe.cooking_term === null && { alignItems: 'flex-start' }) }}>
          {(selectedCategory === null || selectedTerm === null) &&
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                alignContent: 'flex-start'
              }}
            >
              <div
                className="term"
                onClick={() => setSelectedTerm(TERMS.RAW)}
                style={{ ...(selectedTerm === TERMS.RAW && { backgroundColor: mainBgColor }) }} > {TERMS.RAW} </div>
              <div
                className="term"
                onClick={() => setSelectedTerm(TERMS.RARE)}
                style={{ ...(selectedTerm === TERMS.RARE && { backgroundColor: mainBgColor }) }} > {TERMS.RARE} </div>
              <div
                className="term"
                onClick={() => setSelectedTerm(TERMS.MEDIUM_RARE)}
                style={{ ...(selectedTerm === TERMS.MEDIUM_RARE && { backgroundColor: mainBgColor }) }} > {TERMS.MEDIUM_RARE} </div>
              <div
                className="term"
                onClick={() => setSelectedTerm(TERMS.MEDIUM)}
                style={{ ...(selectedTerm === TERMS.MEDIUM && { backgroundColor: mainBgColor }) }} > {TERMS.MEDIUM} </div>
              <div
                className="term"
                onClick={() => setSelectedTerm(TERMS.MED_WELL)}
                style={{ ...(selectedTerm === TERMS.MED_WELL && { backgroundColor: mainBgColor }) }} > {TERMS.MED_WELL} </div>
              <div
                className="term"
                onClick={() => setSelectedTerm(TERMS.WELL_DONE)}
                style={{ ...(selectedTerm === TERMS.WELL_DONE && { backgroundColor: mainBgColor }) }} > {TERMS.WELL_DONE} </div>
            </div>
          }
        </div>
      </article>
    </>
  )
}

export default RunMode;
